const directive = {
  bind(el, binding) {
    addClickEvent(el, binding);
  },
};

function addClickEvent(el, binding) {
  el.addEventListener(
    binding.arg,
    () => {
      binding.value(); //excute the passed function

      // bind the click event with once option after 500 ms , fix: multiple confirmPayment calls
      setTimeout(() => {
        addClickEvent(el, binding);
      }, 500);
    },
    { once: true }
  );
}

export default directive;
